const updates = [
  { title: '《星际征途2》高清版现已上线', time: '3小时前', type: '电影上新' },
  { title: '《暗夜追踪》全集更新完毕，一次看个够', time: '6小时前', type: '剧集完结' },
  { title: '暑期专题「高分动作片连播」已更新', time: '10小时前', type: '专题更新' },
  { title: '播放线路优化完成，加载速度提升30%', time: '1天前', type: '系统优化' },
  { title: '《时光旅人》第三季高清资源已同步', time: '1天前', type: '剧集上新' },
  { title: '新增200+高清纪录片资源', time: '2天前', type: '片库扩充' },
  { title: '「经典港片回顾」专题正式上线', time: '2天前', type: '专题上线' },
  { title: '《深海迷踪》4K修复版独家上线', time: '3天前', type: '电影上新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              更新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              最新高清影视资源上线信息与平台动态
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-5 md:left-6 top-0 bottom-0 w-px bg-background-300/60"></div>

            <div className="space-y-6 md:space-y-7">
              {updates.map((item, i) => (
                <div key={i} className="relative flex items-start gap-4 md:gap-6 pl-12 md:pl-14">
                  <div className={`absolute left-3.5 md:left-4.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-background-50 ${
                    i === 0 ? 'bg-accent-500 border-accent-300' : 'bg-background-300 border-background-200'
                  }`}></div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <span className={`px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                        item.type === '电影上新' || item.type === '剧集上新'
                          ? 'bg-accent-100 text-accent-700'
                          : item.type === '系统优化' || item.type === '片库扩充'
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}>
                        {item.type}
                      </span>
                      <span className="text-xs text-foreground-500">{item.time}</span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}